export default function SectionHeader({
  eyebrow,
  title,
  description,
  align = "left",
  as: Heading = "h2",
}) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-12`}>
      {eyebrow && (
        <div className={`inline-flex items-center gap-2 mb-5 ${align === "center" ? "mx-auto" : ""}`}>
          <span className="h-px w-6 bg-gradient-to-r from-blue-400 to-transparent" />
          <span className="text-xs uppercase tracking-[0.24em] text-blue-400 font-semibold">
            {eyebrow}
          </span>
        </div>
      )}
      <Heading className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.08]">
        {title}
      </Heading>
      {description && (
        <p className="mt-5 text-base sm:text-lg text-gray-400 leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}
